const routes = [
  {
    path: "/manutencao-tipo-informacao-servidor",
    name: "manutencao-tipo-informacao-servidor",
    meta: {
      allowedPermissions: ["tipo_informacao_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoTipoInformacaoServidor/ManutencaoTipoInformacaoServidorHome.vue"
      ),
  },

  {
    path: "/manutencao-tipo-informacao-servidor/novo",
    name: "manutencao-tipo-informacao-servidor-novo",
    meta: {
      allowedPermissions: ["tipo_informacao_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoTipoInformacaoServidor/ManutencaoTipoInformacaoServidorCad.vue"
      ),
  },

  {
    path: "/manutencao-tipo-informacao-servidor/editar/:id",
    name: "manutencao-tipo-informacao-servidor-editar",
    meta: {
      allowedPermissions: ["tipo_informacao_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoTipoInformacaoServidor/ManutencaoTipoInformacaoServidorEdit.vue"
      ),
  },
];

export default routes;
